import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestNav, {
  NavProps,
} from 'ext-ui/design-system/generated/latest/components/Nav/Nav'
import GeneratedLiveNav from 'ext-ui/design-system/generated/live/components/Nav/Nav'
import React, { ReactElement } from 'react'

function renderDesignSystemNav(
  Component: typeof GeneratedLiveNav,
  channel: 'live' | 'latest',
  props: NavProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveNav(props: NavProps): ReactElement {
  return renderDesignSystemNav(GeneratedLiveNav, 'live', props)
}

function LatestNav(props: NavProps): ReactElement {
  return renderDesignSystemNav(GeneratedLatestNav, 'latest', props)
}

function Nav(props: NavProps): ReactElement {
  const ResolvedNav = useResolvedDesignSystemComponent(LiveNav, LatestNav)

  return <ResolvedNav {...props} />
}

export default Nav
export type { NavProps }
